import { render, staticRenderFns } from "./SiteTitle.vue?vue&type=template&id=1106edde&lang=pug&"
import script from "./SiteTitle.vue?vue&type=script&lang=js&"
export * from "./SiteTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports